"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nowWithinTimeRange = exports.nowWithinDateRange = exports.withinTimeRange = exports.withinDateRange = void 0;
/**
 * A function to check weather given date ( in Date Obj or epoch time format ) is within two point of date.
 * @param input - A targeted date
 * @param startDate - starting point of date
 * @param endDate - ending point of date
 * @return {boolean} true/false weather targeted date is in range or not
 */
const withinDateRange = (input, startDate, endDate) => {
    const targetDate = new Date(input).setHours(0, 0, 0, 0);
    const fromDate = new Date(startDate).setHours(0, 0, 0, 0);
    const toDate = endDate ? new Date(endDate).setHours(0, 0, 0, 0) : Infinity;
    return fromDate <= targetDate && targetDate <= toDate;
};
exports.withinDateRange = withinDateRange;
/**
 * A function to check weather given time ( in HH:MM 24hrs format ) is within two point of time.
 * @param input - A targeted time in HH:MM 24hrs format
 * @param startTime - starting point of time in HH:MM 24 hrs format
 * @param endTime - ending point of time in HH:MM 24hrs format
 * @return {boolean} true/false weather targeted time is in range or not
 */
const withinTimeRange = (input, startTime, endTime) => {
    const absoluteTargetTime = Number(input.split(':').join(''));
    const absoluteStartTime = Number(startTime.split(':').join(''));
    const absoluteEndTime = Number(endTime.split(':').join(''));
    return (absoluteStartTime <= absoluteTargetTime &&
        absoluteTargetTime <= absoluteEndTime);
};
exports.withinTimeRange = withinTimeRange;
/**
 * A function to check weather a given date range ( in Date or epoch time format ) includes the today.
 * @param startDate - starting point of date
 * @param endDate - ending point of date
 * @return {boolean} true/false weather today date is in range or not.
 */
const nowWithinDateRange = (startDate, endDate) => {
    const currentDate = new Date();
    return (0, exports.withinDateRange)(currentDate, startDate, endDate);
};
exports.nowWithinDateRange = nowWithinDateRange;
/**
 * A function to check weather current time ( in HH:MM 24hrs format ) is within two point of time.
 * @param startTime - starting point of time in HH:MM 24 hrs format
 * @param endTime - ending point of time in HH:MM 24hrs format
 * @return {boolean} true/false weather targeted time is in range or not
 */
const nowWithinTimeRange = (startTime, endTime) => {
    const currentDate = new Date();
    const hour = currentDate.getHours();
    const minute = String(currentDate.getMinutes()).padStart(2, '0');
    const currentTime = [hour, minute].join(':');
    return (0, exports.withinTimeRange)(currentTime, startTime, endTime);
};
exports.nowWithinTimeRange = nowWithinTimeRange;
//# sourceMappingURL=dateHelper.js.map